import { GET_TAXONOMY_LIST_REQUEST } from '../constants/action-types';

export const getTaxonomyList = (
  types = ['item', 'psychographic', 'demographic']
) => ({
  type: GET_TAXONOMY_LIST_REQUEST,
  types,
});
